<template>
  <div class="entire-layout-wrapper">
    <header-title :title="$t('auth.accountCreation')" />
    <div class="make-account-wrapper">
      <form>
        <!-- Email入力確認 -->
        <div class="input-field">
          <label class="input-field-label" for="email">
            {{ $t("common.mail") }}
          </label>
          <input
            type="email"
            maxlength="128"
            class="form-control"
            v-model="email"
            v-validate="'email'"
            name="email"
            placeholder=""
            :class="{ error: errors.has('email') }"
          />
        </div>
        <div class="invalid-text-container">
          <span class="invalid-text" v-if="errors.has('email')">{{
            $t("auth.incorrectEmail")
          }}</span>
        </div>

        <!-- パスワード入力確認 -->
        <div class="input-field">
          <label class="input-field-label" for="password">
            {{ $t("common.password") }}
          </label>
          <input
            type="password"
            maxlength="128"
            class="form-control"
            v-model="password"
            placeholder="6桁以上"
            v-validate="'required|min:6'"
            name="password"
            v-if="secret == 'password'"
            ref="password"
            :class="{ error: errors.has('password') }"
          />
          <!-- 見えるパスワード入力 -->
          <input
            class="form-control"
            type="text"
            v-model="password"
            v-if="secret == 'text'"
            ref="altPassword"
            v-validate="'required'"
            v-bind:class="{
              'form-control': true,
              error: errors.has('password'),
            }"
          />
        </div>
        <div class="invalid-text-container">
          <span class="invalid-text" v-if="errors.has('password')">{{
            $t("auth.incorrectPassword")
          }}</span>
        </div>

        <!-- 確認パスワード入力確認 -->
        <div class="input-field">
          <label class="input-field-label" for="password">
            {{ $t("common.passwordConfirm") }}
          </label>
          <input
            name="passwordConfirm"
            type="password"
            maxlength="128"
            v-model="passwordConfirm"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            v-if="secret == 'password'"
            class="form-control"
            :class="{ error: errors.has('passwordConfirm') }"
          />
          <input
            class="form-control"
            type="text"
            v-model="passwordConfirm"
            v-if="secret == 'text'"
            v-validate="'required|confirmed:altPassword'"
            v-bind:class="{ error: errors.has('passwordConfirm') }"
          />
        </div>
        <div class="invalid-text-container">
          <span class="invalid-text" v-if="errors.has('passwordConfirm')">{{
            $t("auth.passwordDoNotMatch")
          }}</span>
        </div>

        <!-- パスワード表示チェックボックス入力確認 -->
        <div class="check-field">
          <input
            type="checkbox"
            v-model="secret"
            true-value="text"
            false-value="password"
          />
          {{ $t("auth.displayPassword") }}
        </div>

        <!-- プライバシーポリシーチェックボックス入力確認 -->
        <div class="justify-content-md-center">
          <input
            type="checkbox"
            id="chkAccepted"
            name="chkAccepted"
            :value="true"
            :unchecked-value="false"
            v-model="status"
            v-validate="'required'"
          />
          {{ $t("auth.acceptancePolicy") }}
        </div>
        <!-- プライバシーポリシーチェックエラー -->
        <div class="invalid-text-container">
          <span class="invalid-text" v-if="errors.has('chkAccepted')">{{
            $t("auth.requireAcceptPolicy")
          }}</span>
        </div>
        <!-- プライバシーポリシーURL -->
        <div class="justify-content-md-center">
          <a
            href="https://mirai.karadakarada.com/privacypolicy/"
            target="_blank"
            >＜＜{{ $t("auth.privacyPolicy") }}＞＞</a
          >
        </div>
        <p class="invalid" v-if="isDenied">{{ errorMsg }}</p>

        <next-button
          :label="$t('common.create')"
          @click.prevent="onSignup"
          :disabled="!enabledSighUpButton"
          class="next-button"
        />
      </form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { functions } from "@/firebase/index.js";

import HeaderTitle from "../design/HeaderTitleSlot";
import NextButton from "../components/atoms/NextButton";

export default {
  components: {
    HeaderTitle,
    NextButton,
  },
  data() {
    return {
      isDenied: false,
      errorMsg: "",
      email: "",
      password: "",
      passwordConfirm: "",
      requiredCount: 6,
      deniedPasswordStrings: [
        " ",
        ".",
        "#",
        "$",
        "[",
        "]",
        "(",
        ")",
        "+",
        "-",
        "<",
        "=",
        ">",
        "?",
        "@",
        "^",
        "_",
        "|",
        "~",
      ],
      secret: "password",
      status: false,
      // クーポンを管理
      coupon: {
        couponType: "",
        code: "",
      },
    };
  },
  computed: {
    // isDisabled: function() {
    //   return this.email && this.password  && this.status === true && Object.keys(this.fields).some(key => this.fields[key].valid);
    // },
    // isMached: function(){
    //     // パスワードが一致する場合のみボタンが押される状態になる。
    //   return this.password === this.passwordConfirm && Object.keys(this.fields).some(key => this.fields[key].valid);
    // },

    // "作成"ボタンを押せるか確認する処理
    enabledSighUpButton: function() {
      // メールアドレス・パスワードの入力確認
      if ((this.email && this.password) === false) {
        return false;
      }

      // プライバシーポリシーチェック
      if (this.status === false) {
        return false;
      }

      // ２つのパスワードが一致しているか確認
      if (this.password !== this.passwordConfirm) {
        return false;
      }

      // 必要文字数を満たしているか確認
      if (this.password.length < this.requiredCount) {
        return false;
      }

      // 識別不可文字が存在しないか確認
      for (var count = 0; count < this.deniedPasswordStrings.length; count++) {
        if (this.password[count] === this.deniedPasswordStrings[count]) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    async onSignup() {
      try {
        // FireBaseから認証メール送信
        const credential = await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password);
        const actionCodeSettings = {
          url: process.env.VUE_APP_SIGN_IN_LINK,
          handleCodeInApp: true,
        };
        credential.user.sendEmailVerification(actionCodeSettings);
        this.errorMsg = this.$t("auth.sendEmail");
        this.isDenied = true;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("ERROR", error);
        if (error.code === "auth/email-already-in-use") {
          this.errorMsg = this.$t("auth.alreadyInUse");
        } else if (error.code === "auth/weak-password") {
          this.errorMsg = this.$t("auth.weakPassword");
        } else {
          this.errorMsg = this.$t("auth.incorrectEmailPassword");
        }
        this.isDenied = true;
      }
    },
  },
  created() {
    // どこから遷移してきたかを登録
    this.coupon = this.$route.params.coupon;
    console.log(this.coupon);
  },
};
</script>

<style scoped>
/*全体のレイアウトの余白調整*/
.entire-layout-wrapper {
  width: 60vw;
  align-content: center;
  margin: 0 auto;
}
.make-account-wrapper {
  border: 2px solid #d7d7d7;
  border-radius: 10px;
  width: 100%;
  padding: 40px;
}
.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(100% + 0.25vw);
}
/*validation error 発生領域表示*/
.form-control.error {
  border-color: #e84444;
}
/*正常系*/
.form-control.pass {
  border-color: blue;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(232, 68, 68, 0.6);
}
.input-field {
  display: grid;
  align-items: center;
  gap: 20px;
  grid-template-columns: 1fr 4.5fr;
}
.input-field-label {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.check-field {
  justify-self: start;
}
.justify-content-md-center {
  margin-top: 10px;
}
.next-button {
  margin-top: 20px;
}
/* エラー表記用 */
.invalid-text-container {
  height: 50px;
  text-align: center;
}
.invalid-text {
  color: red;
  line-height: 50px;
}
.invalid {
  color: red;
}
</style>
